export default axios => ({
  /**
   * Список график работы
   *
   * @param date
   * @returns {*}
   */
  list (date) {
    return axios.get('/web/schedule/list', { params: { date } })
  },
  /**
   * Начальные данные графика
   *
   * @param id
   * @returns {*}
   */
  dataForUpdate (id) {
    return axios.get(`/web/playground/get/${id}/edit/schedule`)
  },
  /**
   * Редактирует график
   *
   * @param id
   * @param schedule
   * @returns {*}
   */
  update ({ id, schedule }) {
    return axios.put(`/web/playground/get/${id}/edit/schedule`, { schedule })
  }
})
